import React, { useState } from "react";
import styles from "./Leaderboard.module.scss";
import Fox from "../Champions:folk/Fox.gif";
import Pigeon from "../Champions:folk/Birds.gif";
import Frog from "../Champions:folk/Frog.gif";
import Geography from "../Champions:folk/Rivers.gif";
import Tulip from "../Champions:folk/Plants.gif";
import CabbageWhite from "../Champions:folk/Insects.gif";
import Trophy from "../Champions:folk/Markeroftheweek.gif";

function Leaderboard(props) {
  const tournamentNumbers = props.tournament();
  const setCurrentFilter = props.setCurrentFilter;
  const total =
    tournamentNumbers.mammal +
    tournamentNumbers.bird +
    tournamentNumbers.insect +
    tournamentNumbers.plant +
    tournamentNumbers.water +
    tournamentNumbers["natural feature"];

  return (
    <ul className={styles.tournamentImgs}>
      <li
        onClick={(e) => {
          setCurrentFilter(null);
        }}
      >
        All
        <br />
        {total}
      </li>
      <li
        onClick={(e) => {
          setCurrentFilter("mammal");
        }}
      >
        <img className={styles.image} src={Fox} />
        <br />

        {tournamentNumbers.mammal}
      </li>
      <li
        onClick={(e) => {
          setCurrentFilter("bird");
        }}
      >
        <img className={styles.image} src={Pigeon} />
        <br />
        {tournamentNumbers.bird}
      </li>
      <li
        onClick={(e) => {
          setCurrentFilter("water");
        }}
      >
        <img className={styles.image} src={Frog} />
        <br />
        {tournamentNumbers.water}
      </li>
      <li
        onClick={(e) => {
          setCurrentFilter("natural feature");
        }}
      >
        <img className={styles.image} src={Geography} />
        <br />

        {tournamentNumbers["natural feature"]}
      </li>
      <li
        onClick={(e) => {
          setCurrentFilter("insect");
        }}
      >
        <img className={styles.image} src={CabbageWhite} />
        <br />

        {tournamentNumbers.insect}
      </li>
      <li
        onClick={(e) => {
          setCurrentFilter("plant");
        }}
      >
        <img className={styles.image} src={Tulip} />
        <br />
        {tournamentNumbers.plant}
      </li>
      <li
        onClick={(e) => {
          setCurrentFilter("best");
        }}
      >
        <img className={styles.image} src={Trophy} />
        <br />

        <br />
      </li>
    </ul>
  );
}

export default Leaderboard;
